export default __webpack_public_path__ + "static/media/team-4.b13d07da.png";